import {
  CONVERSATION_FACTS_DIMENSIONS,
  CONVERSATION_FACTS_ZONE_DIMENSIONS,
  DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS,
  DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for Team Availability data
 */
export const TeammateAvailabilityBaseQuery: CubeQuery = {
  name: 'AvailabilityBuckets',
  queryName: 'AvailabilityBuckets',
  query: {
    order: [[DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.DISPLAY_NAME, 'asc']],
    dimensions: [
      DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.USER_ID,
      DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.AVAILABILITY_START_AT_WITH_ZONE,
      DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.AVAILABILITY_END_AT_WITH_ZONE,
      DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.DISPLAY_NAME,
    ],
    measures: [DRIFT_CHAT_USERS_AVAILABILITY_BUCKETS.BUCKET_SUM],
    filters: [
      {
        member: 'DriftChatAppUsers.isBot',
        operator: 'equals',
        values: ['false'],
      },
    ],
  },
}

/**
 * Cube query to get missed and reponded Chats
 */
export const RespondedChatsQuery: CubeQuery = {
  name: 'RespondedChats',
  queryName: 'RespondedChats',
  query: {
    order: [[CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID, 'desc']],
    dimensions: [
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID,
      CONVERSATION_FACTS_ZONE_DIMENSIONS.CONVERSATION_CREATED_AT,
      DRIFT_CHAT_CONVERSATION_ROUTING_DIMENSIONS.HAS_ROUTED_AND_SOMEONE_RESPONDED_WITHIN_60S,
      DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS.USER_ID,
    ],
    filters: [
      {
        member: DRIFT_CHAT_APP_USERS_ONLY_FIRST_ROUTED_USER_DIMENSIONS.USER_ID,
        operator: 'set',
      },
      {
        member: 'DriftChatAppUsers.isBot',
        operator: 'equals',
        values: ['false'],
      },
    ],
  },
}
